/**
 * A phone or plain tablet: under Tailwind's lg (1024px), with a finger as its
 * primary pointer and no way to hover. The `touch-only` variant in index.css
 * is the same query, for markup.
 *
 * A narrow desktop window, browser zoom or split screen keeps its mouse or
 * trackpad as the primary pointer, so it is not touch-only. `any-pointer: fine`
 * was the test before, and it let phones in: Android Chrome reports a fine
 * pointer on most phones (a stylus, or an input device the OS exposes), and 57
 * Android phones used the app in two weeks.
 */
export const TOUCH_ONLY_QUERY =
  '(max-width: 1023.98px) and (pointer: coarse) and (hover: none)';
